module.exports = __webpack_public_path__ + "static/media/circular-clock.a4a71f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circular-clock.png
// module id = 1536
// module chunks = 0